// extracted by mini-css-extract-plugin
export var modal = "index-module--modal--2vJl3";
export var modalOpen = "index-module--modalOpen--30lmH";
export var modalPortal = "index-module--modalPortal--2u40e";
export var left = "index-module--left--ImsmV";
export var center = "index-module--center--3nAXA";
export var icelandairLogo = "index-module--icelandairLogo--2bl-v";
export var relogo = "index-module--relogo--3xHb5";